// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "cally"
import "./controllers"
import * as echarts from 'echarts';
import 'echarts/theme/dark.js';

window.echarts = echarts;

function railsChartNodes(root = document) {
  return root.querySelectorAll("div[id^='rails_charts_']")
}

function resizeRailsCharts() {
  const charts = window.RailsCharts?.charts
  if (!charts) return

  Object.values(charts).forEach((chart) => {
    try {
      chart?.resize?.()
    } catch (_) {
      // instancia ya disposed (Turbo)
    }
  })
}

let chartResizeFrame = null
function scheduleChartResize() {
  if (chartResizeFrame) cancelAnimationFrame(chartResizeFrame)
  chartResizeFrame = requestAnimationFrame(() => {
    chartResizeFrame = null
    resizeRailsCharts()
  })
}

function observeChartContainers(root = document) {
  if (typeof ResizeObserver === "undefined") return

  window.__railsChartsResizeObserver ||= new ResizeObserver(() => scheduleChartResize())
  railsChartNodes(root).forEach((el) => window.__railsChartsResizeObserver.observe(el))
}

function initChartsIn(root) {
  railsChartNodes(root).forEach((el) => {
    const fn = window[`init_${el.id}`]
    if (typeof fn === "function") fn()
  })
  observeChartContainers(root)
  scheduleChartResize()
}

window.addEventListener("resize", scheduleChartResize)
document.addEventListener("chart:rendered", scheduleChartResize)
document.addEventListener("turbo:load", () => {
  observeChartContainers()
  scheduleChartResize()
  setTimeout(resizeRailsCharts, 80)
})
document.addEventListener("turbo:frame-render", (event) => initChartsIn(event.target))

// Los formularios de filtro dentro de un frame con `turbo-action: "advance"` actualizan la
// URL, pero Turbo sube al tope de la página al avanzar. Conservamos la posición del scroll.
let scrollBeforeFrameSubmit = null

document.addEventListener("turbo:submit-start", () => {
  scrollBeforeFrameSubmit = window.scrollY
})

document.addEventListener("turbo:frame-render", () => {
  if (scrollBeforeFrameSubmit === null) return

  const top = scrollBeforeFrameSubmit
  scrollBeforeFrameSubmit = null
  requestAnimationFrame(() => window.scrollTo({ top, behavior: "instant" }))
})


import { Turbo } from "@hotwired/turbo-rails"

Turbo.setConfirmMethod((message, element) => {
  return new Promise((resolve) => {
    const dialog = document.createElement("dialog")
    dialog.className = "modal modal-bottom sm:modal-middle"
    dialog.innerHTML = `
      <div class="modal-box">
        <h3 class="font-bold text-lg text-base-content">Confirmar acción</h3>
        <p class="py-4 text-base-content/80 font-normal">${message}</p>
        <div class="modal-action">
          <button class="btn btn-ghost btn-sm" id="turbo-confirm-cancel">Cancelar</button>
          <button class="btn btn-primary btn-sm" id="turbo-confirm-accept">Aceptar</button>
        </div>
      </div>
      <form method="dialog" class="modal-backdrop">
        <button>close</button>
      </form>
    `
    document.body.appendChild(dialog)
    dialog.showModal()

    dialog.querySelector("#turbo-confirm-accept").addEventListener("click", () => {
      dialog.close()
      resolve(true)
    })

    dialog.querySelector("#turbo-confirm-cancel").addEventListener("click", () => {
      dialog.close()
      resolve(false)
    })

    dialog.addEventListener("close", () => {
      document.body.removeChild(dialog)
      resolve(false) // Safe to resolve false again if already resolved
    })
  })
})
